interface Supplier {
  id?: number;
  taxPayerId?: number;
  fantasyName?: string;
  legalName?: string;
  ruc?: string;
}

export const newSupplier = (): Supplier => {
  return {};
};

export default Supplier;
